import { Route, Routes } from '@angular/router';
import { NextStepItem } from '../pages/thank-you/thank-you.component';
import { errorRoutes } from './error.routes';

export interface Aura404RouteConfig {
  path?: string;
  title?: string;
  badgeText?: string;
  heading?: string;
  description?: string;
  responseTimeText?: string;
  homeUrl?: string;
  homeButtonText?: string;
}

export interface AuraThankYouRouteConfig {
  path?: string;
  title?: string;
  badgeText?: string;
  heading?: string;
  description?: string;
  showResponseTime?: boolean;
  responseTimeTitle?: string;
  responseTimeText?: string;
  nextStepsTitle?: string;
  nextSteps?: NextStepItem[];
  homeUrl?: string;
  homeButtonText?: string;
}

export function createAura404Route(config?: Aura404RouteConfig): Route {
  return {
    path: config?.path ?? '404',
    loadComponent: () =>
      import('../pages/error-404/error-404.component').then((m) => m.AuraError404Component),
    title: config?.title ?? 'Page non trouvée (404)',
    data: {
      ...(config?.badgeText ? { badgeText: config.badgeText } : {}),
      ...(config?.heading ? { title: config.heading } : {}),
      ...(config?.description ? { description: config.description } : {}),
      ...(config?.responseTimeText ? { responseTimeText: config.responseTimeText } : {}),
      ...(config?.homeUrl ? { homeUrl: config.homeUrl } : {}),
      ...(config?.homeButtonText ? { homeButtonText: config.homeButtonText } : {}),
    },
  };
}

export function createAuraThankYouRoute(config?: AuraThankYouRouteConfig): Route {
  return {
    path: config?.path ?? 'thank-you',
    loadComponent: () =>
      import('../pages/thank-you/thank-you.component').then((m) => m.AuraThankYouComponent),
    title: config?.title ?? 'Merci pour votre demande',
    data: {
      ...(config?.badgeText ? { badgeText: config.badgeText } : {}),
      ...(config?.heading ? { title: config.heading } : {}),
      ...(config?.description ? { description: config.description } : {}),
      ...(config?.showResponseTime !== undefined ? { showResponseTime: config.showResponseTime } : {}),
      ...(config?.responseTimeTitle ? { responseTimeTitle: config.responseTimeTitle } : {}),
      ...(config?.responseTimeText ? { responseTimeText: config.responseTimeText } : {}),
      ...(config?.nextStepsTitle ? { nextStepsTitle: config.nextStepsTitle } : {}),
      ...(config?.nextSteps ? { nextSteps: config.nextSteps } : {}),
      ...(config?.homeUrl ? { homeUrl: config.homeUrl } : {}),
      ...(config?.homeButtonText ? { homeButtonText: config.homeButtonText } : {}),
    },
  };
}

export const auraRootChildRoutes: Route[] = [createAuraThankYouRoute()];

export const rootRoutes: Routes = [errorRoutes, { path: '**', redirectTo: '404' }];
